import { useTranslations } from '@/hooks/useTranslations'
import { useCallback, useMemo, useState } from 'react'

import { ModalLayout } from './_Modal'

type UnsaveWarningModalProps = {
  open: boolean
  setIsOpen: (open: boolean) => void
  onDiscard: () => void
  title?: string
  description?: string
}

const UnsaveWarning = ({ open, setIsOpen, onDiscard, title, description }: UnsaveWarningModalProps) => {
  const t = useTranslations()

  return (
    <ModalLayout
      // hero={<CharacterWarning className="size-48" />}
      open={open}
      setIsOpen={setIsOpen}
      title={title || t('modals.unsave_warning.title')}
      description={description || t('modals.unsave_warning.description')}
      cancel={{
        label: t('buttons.not_now'),
      }}
      action={{
        label: t('buttons.discard_changes'),
        action: () => onDiscard(),
      }}
    />
  )
}

export const useUnsaveWarningModal = () => {
  const [openWarningModal, setIsOpenWarningModal] = useState(false)

  const UnsaveWarningModal = useCallback(
    ({ onDiscard, title, description }: { onDiscard: () => void, title?: string, description?: string }) => {
      return (
        <UnsaveWarning
          open={openWarningModal}
          setIsOpen={setIsOpenWarningModal}
          onDiscard={onDiscard}
          title={title}
          description={description}
        />
      )
    },
    [openWarningModal, setIsOpenWarningModal],
  )

  const showUnsaveWarningModal = useCallback(() => {
    setIsOpenWarningModal(true)
  }, [setIsOpenWarningModal])

  return useMemo(
    () => ({
      showUnsaveWarningModal,
      UnsaveWarningModal,
    }),
    [showUnsaveWarningModal, UnsaveWarningModal],
  )
}
